/**
 * 表格空状态。
 *
 * 管理端此前把「暂无记录」直接写在 `TableCell` 里，三个页面的留白与字号各不相同。
 * 统一成一个组件后，空状态与「有数据」时的对齐方式也一致了。
 */
import type { ReactNode } from 'react'

export function EmptyState({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="grid place-items-center gap-2 py-10 text-center">
      <div className="text-sm text-[var(--color-muted-foreground)]">{title}</div>
      {action}
    </div>
  )
}
